var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_23354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14494 8.86249C3.07667 8.75009 3.03124 8.62533 3.01125 8.49534C2.99126 8.36536 2.99711 8.23271 3.02846 8.10498C3.05981 7.97726 3.11605 7.85698 3.19395 7.75102C3.27185 7.64506 3.36988 7.55551 3.48244 7.48749C7.25832 5.20364 11.5871 3.99634 15.9999 3.99634C20.4128 3.99634 24.7416 5.20364 28.5174 7.48749C28.63 7.55551 28.728 7.64506 28.8059 7.75102C28.8838 7.85698 28.9401 7.97726 28.9714 8.10498C29.0028 8.23271 29.0086 8.36536 28.9886 8.49534C28.9686 8.62533 28.9232 8.75009 28.8549 8.86249L16.8549 28.52C16.7659 28.6675 16.6404 28.7895 16.4903 28.8742C16.3403 28.9589 16.171 29.0034 15.9987 29.0034C15.8264 29.0034 15.6571 28.9589 15.507 28.8742C15.357 28.7895 15.2314 28.6675 15.1424 28.52L3.14494 8.86249Z",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73755 11.47C8.05834 9.20914 11.9827 8.00006 16 8.00006C20.0174 8.00006 23.9418 9.20914 27.2626 11.47",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 24.5988C18.7499 24.3542 18.3064 24.008 17.9478 23.5822C17.5892 23.1564 17.3234 22.6605 17.1674 22.1261C17.0114 21.5917 16.9687 21.0306 17.042 20.4788C17.1153 19.927 17.303 19.3965 17.593 18.9214C17.883 18.4462 18.2691 18.0368 18.7264 17.7194C19.1837 17.402 19.7022 17.1835 20.2488 17.078C20.7954 16.9724 21.358 16.9821 21.9006 17.1064C22.4432 17.2308 22.9539 17.467 23.4 17.8",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71753 14.7137C7.09752 14.1688 7.60724 13.7272 8.20066 13.4286C8.79409 13.13 9.45254 12.9839 10.1166 13.0035C10.7806 13.0231 11.4293 13.2078 12.004 13.5409C12.5788 13.8739 13.0616 14.3449 13.4088 14.9113C13.756 15.4776 13.9566 16.1216 13.9926 16.7849C14.0287 17.4482 13.8989 18.1101 13.6151 18.7107C13.3313 19.3114 12.9023 19.8318 12.367 20.2252C11.8316 20.6185 11.2068 20.8724 10.5488 20.9637",
    stroke: "#444A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_23354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.6cb5e69d5e8c0d24469f14f1ec3894b8.svg";
export { ForwardRef as ReactComponent };